/* @generated from adl */
import { declResolver, ScopedDecl } from "./runtime/adl";
import { _AST_MAP as adminui_api } from "./adminui/api";
import { _AST_MAP as adminui_db } from "./adminui/db";
import { _AST_MAP as common } from "./common";
import { _AST_MAP as common_config_aws } from "./common/config/aws";
import { _AST_MAP as common_config_db } from "./common/config/db";
import { _AST_MAP as common_config_flyway } from "./common/config/flyway";
import { _AST_MAP as common_config_frontend } from "./common/config/frontend";
import { _AST_MAP as common_config_log } from "./common/config/log";
import { _AST_MAP as common_db } from "./common/db";
import { _AST_MAP as common_http } from "./common/http";
import { _AST_MAP as common_strings } from "./common/strings";
import { _AST_MAP as common_tabular } from "./common/tabular";
import { _AST_MAP as common_ui } from "./common/ui";
import { _AST_MAP as ferovinum_app_adminapi } from "./ferovinum/app/adminapi";
import { _AST_MAP as ferovinum_app_annotations } from "./ferovinum/app/annotations";
import { _AST_MAP as ferovinum_app_api } from "./ferovinum/app/api";
import { _AST_MAP as ferovinum_app_common } from "./ferovinum/app/common";
import { _AST_MAP as ferovinum_app_config } from "./ferovinum/app/config";
import { _AST_MAP as ferovinum_app_contract } from "./ferovinum/app/contract";
import { _AST_MAP as ferovinum_app_db } from "./ferovinum/app/db";
import { _AST_MAP as ferovinum_app_dealextensionrequests } from "./ferovinum/app/dealextensionrequests";
import { _AST_MAP as ferovinum_app_deliveryoptions } from "./ferovinum/app/deliveryoptions";
import { _AST_MAP as ferovinum_app_dtos } from "./ferovinum/app/dtos";
import { _AST_MAP as ferovinum_app_expenses } from "./ferovinum/app/expenses";
import { _AST_MAP as ferovinum_app_frontegg } from "./ferovinum/app/frontegg";
import { _AST_MAP as ferovinum_app_internalapi } from "./ferovinum/app/internalapi";
import { _AST_MAP as ferovinum_app_invoicing } from "./ferovinum/app/invoicing";
import { _AST_MAP as ferovinum_app_messaging } from "./ferovinum/app/messaging";
import { _AST_MAP as ferovinum_app_nodeapi } from "./ferovinum/app/nodeapi";
import { _AST_MAP as ferovinum_app_nompurchaser } from "./ferovinum/app/nompurchaser";
import { _AST_MAP as ferovinum_app_procurement } from "./ferovinum/app/procurement";
import { _AST_MAP as ferovinum_app_product } from "./ferovinum/app/product";
import { _AST_MAP as ferovinum_app_productionorders } from "./ferovinum/app/productionorders";
import { _AST_MAP as ferovinum_app_productsaleorder } from "./ferovinum/app/productsaleorder";
import { _AST_MAP as ferovinum_app_reporting } from "./ferovinum/app/reporting";
import { _AST_MAP as ferovinum_app_settlementcredit } from "./ferovinum/app/settlementcredit";
import { _AST_MAP as ferovinum_app_stockmovement } from "./ferovinum/app/stockmovement";
import { _AST_MAP as ferovinum_app_stocksync } from "./ferovinum/app/stocksync";
import { _AST_MAP as ferovinum_app_systemcommand } from "./ferovinum/app/systemcommand";
import { _AST_MAP as ferovinum_app_tradesale } from "./ferovinum/app/tradesale";
import { _AST_MAP as ferovinum_app_types } from "./ferovinum/app/types";
import { _AST_MAP as ferovinum_app_uiconfig } from "./ferovinum/app/uiconfig";
import { _AST_MAP as ferovinum_app_uploads } from "./ferovinum/app/uploads";
import { _AST_MAP as ferovinum_app_views } from "./ferovinum/app/views";
import { _AST_MAP as ferovinum_app_workflow } from "./ferovinum/app/workflow";
import { _AST_MAP as ferovinum_datacontracts_capitalisedexpense } from "./ferovinum/datacontracts/capitalisedexpense";
import { _AST_MAP as ferovinum_datacontracts_capitalisedexpensedescription } from "./ferovinum/datacontracts/capitalisedexpensedescription";
import { _AST_MAP as ferovinum_datacontracts_carrier } from "./ferovinum/datacontracts/carrier";
import { _AST_MAP as ferovinum_datacontracts_common } from "./ferovinum/datacontracts/common";
import { _AST_MAP as ferovinum_datacontracts_contractnote } from "./ferovinum/datacontracts/contractnote";
import { _AST_MAP as ferovinum_datacontracts_deal } from "./ferovinum/datacontracts/deal";
import { _AST_MAP as ferovinum_datacontracts_deal_roll_recompute } from "./ferovinum/datacontracts/deal_roll_recompute";
import { _AST_MAP as ferovinum_datacontracts_dealleg } from "./ferovinum/datacontracts/dealleg";
import { _AST_MAP as ferovinum_datacontracts_deallegsale } from "./ferovinum/datacontracts/deallegsale";
import { _AST_MAP as ferovinum_datacontracts_dealroll } from "./ferovinum/datacontracts/dealroll";
import { _AST_MAP as ferovinum_datacontracts_dls_stamp_recompute } from "./ferovinum/datacontracts/dls_stamp_recompute";
import { _AST_MAP as ferovinum_datacontracts_expense } from "./ferovinum/datacontracts/expense";
import { _AST_MAP as ferovinum_datacontracts_expenseorigin } from "./ferovinum/datacontracts/expenseorigin";
import { _AST_MAP as ferovinum_datacontracts_expensesettlement } from "./ferovinum/datacontracts/expensesettlement";
import { _AST_MAP as ferovinum_datacontracts_expensestatusevent } from "./ferovinum/datacontracts/expensestatusevent";
import { _AST_MAP as ferovinum_datacontracts_fsp } from "./ferovinum/datacontracts/fsp";
import { _AST_MAP as ferovinum_datacontracts_fxrate } from "./ferovinum/datacontracts/fxrate";
import { _AST_MAP as ferovinum_datacontracts_invoice } from "./ferovinum/datacontracts/invoice";
import { _AST_MAP as ferovinum_datacontracts_invoicelineitem } from "./ferovinum/datacontracts/invoicelineitem";
import { _AST_MAP as ferovinum_datacontracts_marketdata } from "./ferovinum/datacontracts/marketdata";
import { _AST_MAP as ferovinum_datacontracts_newdealrequest } from "./ferovinum/datacontracts/newdealrequest";
import { _AST_MAP as ferovinum_datacontracts_newdealrequestlineitem } from "./ferovinum/datacontracts/newdealrequestlineitem";
import { _AST_MAP as ferovinum_datacontracts_nominatedpurchaser } from "./ferovinum/datacontracts/nominatedpurchaser";
import { _AST_MAP as ferovinum_datacontracts_organisation } from "./ferovinum/datacontracts/organisation";
import { _AST_MAP as ferovinum_datacontracts_product } from "./ferovinum/datacontracts/product";
import { _AST_MAP as ferovinum_datacontracts_productstockdetail } from "./ferovinum/datacontracts/productstockdetail";
import { _AST_MAP as ferovinum_datacontracts_purchaser } from "./ferovinum/datacontracts/purchaser";
import { _AST_MAP as ferovinum_datacontracts_purchaserequest } from "./ferovinum/datacontracts/purchaserequest";
import { _AST_MAP as ferovinum_datacontracts_purchaserequestadditionalcost } from "./ferovinum/datacontracts/purchaserequestadditionalcost";
import { _AST_MAP as ferovinum_datacontracts_purchaserequestlineitem } from "./ferovinum/datacontracts/purchaserequestlineitem";
import { _AST_MAP as ferovinum_datacontracts_saleorder } from "./ferovinum/datacontracts/saleorder";
import { _AST_MAP as ferovinum_datacontracts_saleproduct } from "./ferovinum/datacontracts/saleproduct";
import { _AST_MAP as ferovinum_datacontracts_storagelocation } from "./ferovinum/datacontracts/storagelocation";
import { _AST_MAP as ferovinum_datacontracts_supplier } from "./ferovinum/datacontracts/supplier";
import { _AST_MAP as ferovinum_datacontracts_tradesale } from "./ferovinum/datacontracts/tradesale";
import { _AST_MAP as ferovinum_sourcecontracts_capitalisedexpense } from "./ferovinum/sourcecontracts/capitalisedexpense";
import { _AST_MAP as ferovinum_sourcecontracts_capitalisedexpensedescription } from "./ferovinum/sourcecontracts/capitalisedexpensedescription";
import { _AST_MAP as ferovinum_sourcecontracts_carrier } from "./ferovinum/sourcecontracts/carrier";
import { _AST_MAP as ferovinum_sourcecontracts_common } from "./ferovinum/sourcecontracts/common";
import { _AST_MAP as ferovinum_sourcecontracts_contractnote } from "./ferovinum/sourcecontracts/contractnote";
import { _AST_MAP as ferovinum_sourcecontracts_deal } from "./ferovinum/sourcecontracts/deal";
import { _AST_MAP as ferovinum_sourcecontracts_dealextensionrequest } from "./ferovinum/sourcecontracts/dealextensionrequest";
import { _AST_MAP as ferovinum_sourcecontracts_dealleg } from "./ferovinum/sourcecontracts/dealleg";
import { _AST_MAP as ferovinum_sourcecontracts_deallegsale } from "./ferovinum/sourcecontracts/deallegsale";
import { _AST_MAP as ferovinum_sourcecontracts_dealroll } from "./ferovinum/sourcecontracts/dealroll";
import { _AST_MAP as ferovinum_sourcecontracts_dealterms } from "./ferovinum/sourcecontracts/dealterms";
import { _AST_MAP as ferovinum_sourcecontracts_invoice } from "./ferovinum/sourcecontracts/invoice";
import { _AST_MAP as ferovinum_sourcecontracts_invoicepayment } from "./ferovinum/sourcecontracts/invoicepayment";
import { _AST_MAP as ferovinum_sourcecontracts_negativestockadjustment } from "./ferovinum/sourcecontracts/negativestockadjustment";
import { _AST_MAP as ferovinum_sourcecontracts_negativestockadjustmentsaleorder } from "./ferovinum/sourcecontracts/negativestockadjustmentsaleorder";
import { _AST_MAP as ferovinum_sourcecontracts_newdealrequest } from "./ferovinum/sourcecontracts/newdealrequest";
import { _AST_MAP as ferovinum_sourcecontracts_nominatedpurchaser } from "./ferovinum/sourcecontracts/nominatedpurchaser";
import { _AST_MAP as ferovinum_sourcecontracts_nominatedpurchaserterms } from "./ferovinum/sourcecontracts/nominatedpurchaserterms";
import { _AST_MAP as ferovinum_sourcecontracts_organisation } from "./ferovinum/sourcecontracts/organisation";
import { _AST_MAP as ferovinum_sourcecontracts_physicaladdress } from "./ferovinum/sourcecontracts/physicaladdress";
import { _AST_MAP as ferovinum_sourcecontracts_product } from "./ferovinum/sourcecontracts/product";
import { _AST_MAP as ferovinum_sourcecontracts_productionorder } from "./ferovinum/sourcecontracts/productionorder";
import { _AST_MAP as ferovinum_sourcecontracts_productionordertask } from "./ferovinum/sourcecontracts/productionordertask";
import { _AST_MAP as ferovinum_sourcecontracts_productionordertaskrun } from "./ferovinum/sourcecontracts/productionordertaskrun";
import { _AST_MAP as ferovinum_sourcecontracts_productlineitem } from "./ferovinum/sourcecontracts/productlineitem";
import { _AST_MAP as ferovinum_sourcecontracts_purchaser } from "./ferovinum/sourcecontracts/purchaser";
import { _AST_MAP as ferovinum_sourcecontracts_purchaserequest } from "./ferovinum/sourcecontracts/purchaserequest";
import { _AST_MAP as ferovinum_sourcecontracts_purchaserequestadditionalcost } from "./ferovinum/sourcecontracts/purchaserequestadditionalcost";
import { _AST_MAP as ferovinum_sourcecontracts_purchaserequestlineitem } from "./ferovinum/sourcecontracts/purchaserequestlineitem";
import { _AST_MAP as ferovinum_sourcecontracts_ratescurve } from "./ferovinum/sourcecontracts/ratescurve";
import { _AST_MAP as ferovinum_sourcecontracts_revaluationrequest } from "./ferovinum/sourcecontracts/revaluationrequest";
import { _AST_MAP as ferovinum_sourcecontracts_revaluationrequestlineitem } from "./ferovinum/sourcecontracts/revaluationrequestlineitem";
import { _AST_MAP as ferovinum_sourcecontracts_saleorder } from "./ferovinum/sourcecontracts/saleorder";
import { _AST_MAP as ferovinum_sourcecontracts_stockmovement } from "./ferovinum/sourcecontracts/stockmovement";
import { _AST_MAP as ferovinum_sourcecontracts_storagelocation } from "./ferovinum/sourcecontracts/storagelocation";
import { _AST_MAP as ferovinum_sourcecontracts_supplier } from "./ferovinum/sourcecontracts/supplier";
import { _AST_MAP as sys_adlast } from "./sys/adlast";
import { _AST_MAP as sys_annotations } from "./sys/annotations";
import { _AST_MAP as sys_types } from "./sys/types";

export const ADL: { [key: string]: ScopedDecl } = {
  ...adminui_api,
  ...adminui_db,
  ...common,
  ...common_config_aws,
  ...common_config_db,
  ...common_config_flyway,
  ...common_config_frontend,
  ...common_config_log,
  ...common_db,
  ...common_http,
  ...common_strings,
  ...common_tabular,
  ...common_ui,
  ...ferovinum_app_adminapi,
  ...ferovinum_app_annotations,
  ...ferovinum_app_api,
  ...ferovinum_app_common,
  ...ferovinum_app_config,
  ...ferovinum_app_contract,
  ...ferovinum_app_db,
  ...ferovinum_app_dealextensionrequests,
  ...ferovinum_app_deliveryoptions,
  ...ferovinum_app_dtos,
  ...ferovinum_app_expenses,
  ...ferovinum_app_frontegg,
  ...ferovinum_app_internalapi,
  ...ferovinum_app_invoicing,
  ...ferovinum_app_messaging,
  ...ferovinum_app_nodeapi,
  ...ferovinum_app_nompurchaser,
  ...ferovinum_app_procurement,
  ...ferovinum_app_product,
  ...ferovinum_app_productionorders,
  ...ferovinum_app_productsaleorder,
  ...ferovinum_app_reporting,
  ...ferovinum_app_settlementcredit,
  ...ferovinum_app_stockmovement,
  ...ferovinum_app_stocksync,
  ...ferovinum_app_systemcommand,
  ...ferovinum_app_tradesale,
  ...ferovinum_app_types,
  ...ferovinum_app_uiconfig,
  ...ferovinum_app_uploads,
  ...ferovinum_app_views,
  ...ferovinum_app_workflow,
  ...ferovinum_datacontracts_capitalisedexpense,
  ...ferovinum_datacontracts_capitalisedexpensedescription,
  ...ferovinum_datacontracts_carrier,
  ...ferovinum_datacontracts_common,
  ...ferovinum_datacontracts_contractnote,
  ...ferovinum_datacontracts_deal,
  ...ferovinum_datacontracts_deal_roll_recompute,
  ...ferovinum_datacontracts_dealleg,
  ...ferovinum_datacontracts_deallegsale,
  ...ferovinum_datacontracts_dealroll,
  ...ferovinum_datacontracts_dls_stamp_recompute,
  ...ferovinum_datacontracts_expense,
  ...ferovinum_datacontracts_expenseorigin,
  ...ferovinum_datacontracts_expensesettlement,
  ...ferovinum_datacontracts_expensestatusevent,
  ...ferovinum_datacontracts_fsp,
  ...ferovinum_datacontracts_fxrate,
  ...ferovinum_datacontracts_invoice,
  ...ferovinum_datacontracts_invoicelineitem,
  ...ferovinum_datacontracts_marketdata,
  ...ferovinum_datacontracts_newdealrequest,
  ...ferovinum_datacontracts_newdealrequestlineitem,
  ...ferovinum_datacontracts_nominatedpurchaser,
  ...ferovinum_datacontracts_organisation,
  ...ferovinum_datacontracts_product,
  ...ferovinum_datacontracts_productstockdetail,
  ...ferovinum_datacontracts_purchaser,
  ...ferovinum_datacontracts_purchaserequest,
  ...ferovinum_datacontracts_purchaserequestadditionalcost,
  ...ferovinum_datacontracts_purchaserequestlineitem,
  ...ferovinum_datacontracts_saleorder,
  ...ferovinum_datacontracts_saleproduct,
  ...ferovinum_datacontracts_storagelocation,
  ...ferovinum_datacontracts_supplier,
  ...ferovinum_datacontracts_tradesale,
  ...ferovinum_sourcecontracts_capitalisedexpense,
  ...ferovinum_sourcecontracts_capitalisedexpensedescription,
  ...ferovinum_sourcecontracts_carrier,
  ...ferovinum_sourcecontracts_common,
  ...ferovinum_sourcecontracts_contractnote,
  ...ferovinum_sourcecontracts_deal,
  ...ferovinum_sourcecontracts_dealextensionrequest,
  ...ferovinum_sourcecontracts_dealleg,
  ...ferovinum_sourcecontracts_deallegsale,
  ...ferovinum_sourcecontracts_dealroll,
  ...ferovinum_sourcecontracts_dealterms,
  ...ferovinum_sourcecontracts_invoice,
  ...ferovinum_sourcecontracts_invoicepayment,
  ...ferovinum_sourcecontracts_negativestockadjustment,
  ...ferovinum_sourcecontracts_negativestockadjustmentsaleorder,
  ...ferovinum_sourcecontracts_newdealrequest,
  ...ferovinum_sourcecontracts_nominatedpurchaser,
  ...ferovinum_sourcecontracts_nominatedpurchaserterms,
  ...ferovinum_sourcecontracts_organisation,
  ...ferovinum_sourcecontracts_physicaladdress,
  ...ferovinum_sourcecontracts_product,
  ...ferovinum_sourcecontracts_productionorder,
  ...ferovinum_sourcecontracts_productionordertask,
  ...ferovinum_sourcecontracts_productionordertaskrun,
  ...ferovinum_sourcecontracts_productlineitem,
  ...ferovinum_sourcecontracts_purchaser,
  ...ferovinum_sourcecontracts_purchaserequest,
  ...ferovinum_sourcecontracts_purchaserequestadditionalcost,
  ...ferovinum_sourcecontracts_purchaserequestlineitem,
  ...ferovinum_sourcecontracts_ratescurve,
  ...ferovinum_sourcecontracts_revaluationrequest,
  ...ferovinum_sourcecontracts_revaluationrequestlineitem,
  ...ferovinum_sourcecontracts_saleorder,
  ...ferovinum_sourcecontracts_stockmovement,
  ...ferovinum_sourcecontracts_storagelocation,
  ...ferovinum_sourcecontracts_supplier,
  ...sys_adlast,
  ...sys_annotations,
  ...sys_types,
};

export const RESOLVER = declResolver(ADL);
